module.exports = __webpack_public_path__ + "static/img/retta.646a32f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retta.jpg
// module id = 179
// module chunks = 2